import { Autocomplete, Box, CircularProgress, Container, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, Tab, Tabs, TextField, Typography } from "@mui/material";
import { useCasUserContext } from "../../services/casUserContext";
import { useEffect, useState } from "react";
import { GrupoCompletoDTO, GrupoInvestigacionDTO, PersonaGrupo, voidGrupoCompletoDTO } from "../../interfaces/Grupos/GruposDTO";
import { useNavigate } from "react-router-dom";
import { DeudasTable } from "../../componentes/Deudas/DeudasTable";
import { ButtonTip } from "../../componentes/Common/ButtonTip";
import { FaPlusSquare } from "react-icons/fa";
import { DeudasTableTipo } from "../../componentes/Deudas/DeudasTipo";
import { TipoObligacionDTO } from "../../interfaces/Deudas/DeudasDTO";
import FondoRotativoService from "../../services/FondoRotativoService";
import { TbSearch } from "react-icons/tb";
import ConsultasService from "../../services/ConsultaService";
import { DeudasTablePersona } from "../../componentes/Deudas/DeudasPersona";


const fondos = new FondoRotativoService();
const consultaService = new ConsultasService();

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const DeudasPage: React.FC<{}> = () => {
    let history = useNavigate();
    const casUserContext = useCasUserContext();
    const userData = casUserContext.userData;
    const token = casUserContext.token;
    const [estado, setEstado] = useState('P');
    const [tiposObligaciones, setTiposObligaciones] = useState<Array<TipoObligacionDTO>>([])
    const [openModal, setOpenModal] = useState(false);
    const [grupo, setGrupo] = useState<GrupoCompletoDTO>(voidGrupoCompletoDTO());
    const [value, setValue] = useState(0);
    const [tipo, setTipo] = useState(0);
    const [scry, setScry] = useState(true);
    const [scry2, setScry2] = useState(true);
    const [scry3, setScry3] = useState(true);
    const [openAutocomplete, setOpenAutocomplete] = useState(false);
    const [busquedaParametro, setBusquedaParametro] = useState('');
    const [loadingPer, setLoadingPer] = useState(false);
    const [personas, setPersonas] = useState<Array<PersonaGrupo>>([]);
    const [idbusqueda, setIdbusqueda] = useState(0);
    const [modo, setModo] = useState('E');

    useEffect(() => {
        GetTipos()
    }, [])

    useEffect(() => {
        setScry(false);
        setTimeout(() => {
            setScry(true);
        }, 500);
    }, [estado])

    useEffect(() => {
        setScry2(false);
        setTimeout(() => {
            setScry2(true);
        }, 250);
    }, [tipo])

    useEffect(() => {
        setScry3(false);
        setTimeout(() => {
            setScry3(true);
        }, 500);
    }, [estado])

    const PersonaEspol = async () => {
        if (busquedaParametro.length >= 3) {
            setLoadingPer(true);
            try {
                await consultaService.PersonasByNombre(modo, busquedaParametro, token)
                    .then((data) => {
                        if (data.status.isSuccessfully) {
                            setPersonas(data.listData)
                            if (data.listData.length > 0) {
                                setOpenAutocomplete(true);
                            } else {
                                setOpenAutocomplete(false);
                            }
                        } else {
                            console.error(data.status.messages)
                        }
                    }).finally(() => {
                        setLoadingPer(false);
                    }
                    )
            } catch (error) {
                console.error("Error al obtener personas:", error);
                setLoadingPer(false);
            }
        }
    };

    const handleKeyDownBusqueda = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault(); // evita enviar el formulario
            console.log("Presionó Enter. Buscar:", event.currentTarget.value);
            PersonaEspol(); // por ejemplo
        }
    };

    const GetTipos = async () => {
        await fondos.GetTiposObligaciones(token)
            .then((data) => {
                //console.log(data)
                setTiposObligaciones(data.listData)
            })
            .catch((error) => console.error(error));
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const closeModal = () => {
        setOpenModal(false);
    }

    const goToNavigation = (site: string) => {
        history(site)
    }

    const HandleResponse = (respuesta: GrupoInvestigacionDTO) => {
        if (respuesta.iddecinvgrupoinvestigacion > 0) {
            goToNavigation('/Grupo/' + respuesta.iddecinvgrupoinvestigacion)
        }
    }

    return (
        <Container sx={{ mt: 5, mb: 4, border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
            <br />
            <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Typography variant="h6"><strong>Gestión de Deudas Institucionales</strong></Typography>
                        <ButtonTip nombre={"Nueva Deuda"} onClick={() => goToNavigation('/Deudas/0')}>
                            <FaPlusSquare />
                        </ButtonTip>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Deudas" {...a11yProps(0)} />
                            <Tab label="Por Estado" {...a11yProps(1)} />
                            <Tab label="Por Tipo" {...a11yProps(2)} />
                            <Tab label="Por Persona" {...a11yProps(3)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <DeudasTable token={userData.token} idpersona={0} estado="" />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <FormControl sx={{ m: 1 }} fullWidth >
                            <InputLabel htmlFor="select-class">Estado</InputLabel>
                            <Select
                                labelId="select-class"
                                name="estado"
                                label='Estado'
                                variant="outlined"
                                value={estado}
                                onChange={(event) => setEstado(event.target.value)}
                                sx={{ marginBottom: '20px', width: '100%' }}
                            >
                                <MenuItem key={'estado-P'} value={'P'}>
                                    {'Pendiente'}
                                </MenuItem>
                                <MenuItem key={'estado-L'} value={'L'}>
                                    {'Liberada'}
                                </MenuItem>
                                <MenuItem key={'estado-V'} value={'V'}>
                                    {'Vencida'}
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <br />
                        {scry ? <DeudasTable token={userData.token} idpersona={0} estado={estado} /> : <></>}
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <FormControl sx={{ m: 1 }} fullWidth >
                            <InputLabel htmlFor="select-class">Tipo de deuda</InputLabel>
                            <Select
                                labelId="select-class"
                                name="idInvTipoObligacion"
                                label='Tipo de deuda'
                                variant="outlined"
                                value={tipo}
                                onChange={(event) => setTipo(Number(event.target.value))}
                                sx={{ marginBottom: '20px', width: '100%' }}
                            >
                                <MenuItem value={0}>Seleccione Tipo de deuda</MenuItem>
                                {tiposObligaciones.map((tipo) => (
                                    <MenuItem key={tipo.iddecinvtipoobligacion} value={tipo.iddecinvtipoobligacion}>
                                        {tipo.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <br />
                        {scry2 ? <DeudasTableTipo token={userData.token} idtipo={tipo} /> : <></>}
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Buscar por</FormLabel>
                            <RadioGroup
                                row
                                name="tipoBusqueda"
                                value={modo}
                                onChange={(e) => setModo(e.target.value as "N" | "E")}
                            >
                                <FormControlLabel
                                    value="N"
                                    control={<Radio />}
                                    label="Nombre"
                                />
                                <FormControlLabel
                                    value="E"
                                    control={<Radio />}
                                    label="Email"
                                />
                            </RadioGroup>
                        </FormControl>
                        <FormControl sx={{ m: 1 }} fullWidth>
                            <Autocomplete
                                open={openAutocomplete}
                                onOpen={() => setOpenAutocomplete(true)}
                                onClose={() => setOpenAutocomplete(false)}
                                freeSolo
                                options={personas}
                                getOptionLabel={(option) => {
                                    if (typeof option === "string") return option;
                                    return `${option.nombrecompleto} - ${option.email}`;
                                }}
                                filterOptions={(options) => options}
                                value={null}
                                inputValue={busquedaParametro}
                                onInputChange={(event, newInputValue) => {
                                    setBusquedaParametro(newInputValue);
                                }}
                                onChange={(event, newValue) => {
                                    //console.log("Seleccionado:", newValue);
                                    if (newValue && typeof newValue !== "string") {
                                        setIdbusqueda(newValue.idpersona);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Búsqueda"
                                        onKeyDown={handleKeyDownBusqueda}
                                        fullWidth
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loadingPer && (
                                                        <InputAdornment position="end">
                                                            <CircularProgress size={20} />
                                                        </InputAdornment>
                                                    )}
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={PersonaEspol}
                                                            disabled={loadingPer || !busquedaParametro?.trim()}
                                                        >
                                                            <TbSearch />
                                                        </IconButton>
                                                    </InputAdornment>
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                        <br />
                        {scry3 ? <DeudasTablePersona token={userData.token} idpersona={idbusqueda} /> : <></>}
                    </CustomTabPanel>
                </Grid>
            </Grid>
        </Container>
    );
}